/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MediaFile,
    MediaFileFromJSON,
    MediaFileFromJSONTyped,
    MediaFileToJSON,
    MediaFileBundle,
    MediaFileBundleFromJSON,
    MediaFileBundleFromJSONTyped,
    MediaFileBundleToJSON,
} from './';

/**
 * 
 * @export
 * @interface MediaFileContents
 */
export interface MediaFileContents {
    /**
     * 
     * @type {Array<MediaFile>}
     * @memberof MediaFileContents
     */
    readonly directories: Array<MediaFile>;
    /**
     * 
     * @type {Array<MediaFileBundle>}
     * @memberof MediaFileContents
     */
    readonly bundles: Array<MediaFileBundle>;
    /**
     * 
     * @type {number}
     * @memberof MediaFileContents
     */
    total: number;
}

export function MediaFileContentsFromJSON(json: any): MediaFileContents {
    return MediaFileContentsFromJSONTyped(json, false);
}

export function MediaFileContentsFromJSONTyped(json: any, ignoreDiscriminator: boolean): MediaFileContents {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'directories': ((json['directories'] as Array<any>).map(MediaFileFromJSON)),
        'bundles': ((json['bundles'] as Array<any>).map(MediaFileBundleFromJSON)),
        'total': json['total'],
    };
}

export function MediaFileContentsToJSON(value?: MediaFileContents | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
    };
}


